import React, { useEffect, useState } from "react";

import { Preview } from "@creatomate/preview";
import { getDuration } from "app/utils";

interface SeekbarProps {
  preview?: Preview;
  time: number;
}

const Seekbar: React.FC<SeekbarProps> = ({ preview, time }) => {
  const [seekValue, setSeekValue] = useState(0);

  useEffect(
    () => {
      if (preview?.state?.duration) setSeekValue((time * 100) / preview.state.duration);
    }, [time, preview]
  );

  const handleSeekBarUpdate = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!preview) return;

    const seekto = (preview.state?.duration || 0) * (+event.target.value / 100);
    setSeekValue(+event.target.value);
    preview.setTime(seekto);
  };

  return (
    <>
      <input
        className="Seek-Bar"
        type="range"
        min="0"
        max="100"
        step="1"
        value={seekValue}
        onChange={handleSeekBarUpdate}
      />
      <span className="Video-Duration">
        {getDuration(time)}/{getDuration(preview?.state?.duration)}
      </span>
    </>
  );
};

export default Seekbar;
